import React, {useEffect, useState} from 'react';
import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {ListItem} from './item';
import InternalTemplate from '../../../../../../components/templates/internal';
import {ICandidateOrderItem} from '../../../../../../interfaces/dtos';
import {StackParamList} from '../../../../../../navigators';
import {SpinnerModal} from '../../../../../../components/modals';
import {EmptyListIcon} from '../../../../../../components/icons';
import {useSalesmanContext} from '../../../../../../context/salesman';
import useToast from '../../../../../../hooks';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'OrderListCandidateScreen'
>;

const OrderListCandidateScreen = ({navigation}: ScreenProps) => {
  const [filtered, setFiltered] = useState([] as ICandidateOrderItem[]);
  const [isLoading, setIsLoading] = useState(false);
  const {showServerError} = useToast();
  const {fetchOrderCandidates, orderCandidates, fetchCandidateOrderDetail} =
    useSalesmanContext();

  const getList = async () => {
    setIsLoading(true);
    setFiltered([]);
    try {
      const ready = await fetchOrderCandidates();
      if (!ready) {
        showServerError();
      }
    } catch (ex) {
      showServerError();
    }

    setIsLoading(false);
  };

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFiltered(orderCandidates ?? []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderCandidates]);

  const handleGoBack = () => {
    navigation.pop(1);
  };

  const handleSelectItem = async (index: number) => {
    setIsLoading(true);
    try {
      if (await fetchCandidateOrderDetail(`${filtered[index].id}`)) {
        navigation.navigate('SalesmanOrderBegin', {fromTemplate: true});
      }
    } catch {}

    setIsLoading(false);
  };

  function isOdd(num: number) {
    return num % 2;
  }

  const showContent = () => {
    if (isLoading) {
      return <></>;
    }
    if (orderCandidates?.length === 0) {
      return <EmptyListIcon />;
    }
    if (filtered) {
      return filtered.map((balance: ICandidateOrderItem, index: number) => (
        <ListItem
          key={`balance-item-${index}`}
          id={balance.id}
          type={balance.type}
          summary={balance.summary}
          amount={balance.amount}
          onPress={() => handleSelectItem(index)}
          rowType={isOdd(index) ? 'odd' : 'even'}
        />
      ));
    }

    return <></>;
  };

  return (
    <InternalTemplate
      title={'screen-order-candidate-list-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-dashboard',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />
      <Box marginBottom={20}>{showContent()}</Box>
    </InternalTemplate>
  );
};
export default OrderListCandidateScreen;
